export default __webpack_public_path__ + "static/media/linkdin-icon.14daeca8.svg";